import { Component, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { Item } from 'src/app/models/SelectItems';
import { AdminService } from 'src/app/services/admin.service';
import { GeneralService } from 'src/app/services/general.service';
import { MenuService } from 'src/app/services/menu.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { PolicyLogViewComponent } from '../policy-log-view/policy-log-view.component';
import { LookUpService } from 'src/app/services/lookup.service';
import * as moment from 'moment';
@Component({
  selector: 'app-policy-log-listing',
  templateUrl: './policy-log-listing.component.html',
  styleUrls: ['./policy-log-listing.component.css']
})
export class PolicyLogListingComponent {
  graphdata: any[] = [];
  visibleColumnData: Item[] = [];
  visibleColumnsId:any[] = [];
  graphHeader :any[]=[];
  canView:boolean = false;
  canEdit:boolean = false;
  canDelete:boolean = false;
  canCreate:boolean = false;
  viewUrl:string="";
  editUrl:string="";
  createUrl:string="";
  deleteUrl:string="";
  distributorList:Item[]=[];
  userType:string='3';
  distributorId:number = 0;
  modalRef?: BsModalRef ;
  insuranceCopanyList:Item[]=[];
  insuranceCopanyListTemp:Item[]=[];
  productList:Item[]=[];
  statusList:Item[]=[];
  apiNameList:Item[]=[];
  selectedInsuranceCopanyIds:string="";
  selectedProductIds:string="";
  selectedStatus:string ="Failed";
  selectedAPIName:string="GetQuote";
  today = new Date();
  selectedStartDate:any = moment(this.today).add(-1, 'days').format('YYYY-MM-DD');
  selectedEndDate:any = moment(this.today).format('YYYY-MM-DD');
  selectedDateRange:string="Past 2 Days";
  showLoader:boolean = false;
  constructor(private adminService: AdminService, private router:Router,private menuService:MenuService,private generalService: GeneralService,
    private modalService: BsModalService,private _lookupService :LookUpService) {
    let obj = this.router.getCurrentNavigation()?.extras?.state;
    if(obj)
    {      
      this.getPermissions(parseInt(obj['id'])??0);
    }
    
    this.userType = generalService.getUserType();
    this.getPolicyCompIncomDetails();

    this.loadInsurancePartners();
    // this.loadProductList();
    // this.loadApiNameList();
    this.loadStatusList();
  }

async getPolicyCompIncomDetails() {
  this.showLoader = true;
  this.graphdata = [];
  this.visibleColumnData = []; 
  this.visibleColumnsId = [];
  let obj ={
    "from": moment(this.selectedStartDate).format('YYYY-MM-DD'),
    "to": moment(this.selectedEndDate).format('YYYY-MM-DD'),
    "apI_Name": this.selectedAPIName,
    "status": this.selectedStatus,
    "userId": 0,
    "productIds": this.selectedProductIds,
    "insuranceCopanyIds": this.selectedInsuranceCopanyIds,
    "systemCompanyId": 1
  };
  
    const res = await this.adminService.PolicyLogListing(obj);    
    if (res != null && res.result) {
      this.showLoader = false;
      this.graphdata = res.result.data;
      let index=13;
      let sort:string='desc';
      console.log(this.graphdata.sort( (a, b) => {
        if(sort == 'desc')
        {
          if (a[index].toString().toLowerCase() > b[index].toString().toLowerCase()) {
            return -1;
          }
          if (b[index].toString().toLowerCase() > a[index].toString().toLowerCase()) {
              return 1;
          }          
        }
        else
        {
          if (a[index].toString().toLowerCase() < b[index].toString().toLowerCase()) {
            return -1;
          }
          if (b[index].toString().toLowerCase() < a[index].toString().toLowerCase()) {
              return 1;
          }  
        }
        return index;
      }));
      this.graphHeader = res.result.header;
      if(this.selectedProductIds != "" && !(this.selectedProductIds?.includes("1") || this.selectedProductIds?.includes("2") || this.selectedProductIds?.includes("3"))){
        this.visibleColumnData = res.result.header?.map((m:any,index:number)=>{return {id:index.toString(),name:m.key,checked:true}}).filter((f:any)=>{return !f.name.startsWith('Hidden_') && f.name != 'Regi. Number' && f.name != 'Make' && f.name != 'Model' && f.name != 'Variant'});      
      }
      else
      {
        this.visibleColumnData = res.result.header?.map((m:any,index:number)=>{return {id:index.toString(),name:m.key,checked:true}}).filter((f:any)=>{return !f.name.startsWith('Hidden_')});
      }
      this.visibleColumnsId = this.visibleColumnData.map((m:any)=>{return m.id.toString()});
    }
    else{
      this.showLoader = false;
    }
  }

  onActionClick(data:any)
  {
    if(data)
    {
      if(data.action=="View")
      {
        const initialState: any = {
          list: [
            {
              "id": data.id,
              "isFailed": data.id1
            }
          ]
        };
        let config = {
          animated: false,
          initialState : initialState
        };
        this.modalRef = this.modalService.show(PolicyLogViewComponent,config);
      }
    }
  }

  async getPermissions(menuId:number)
  {
    let obj = {uniqueUserId:this.generalService.getUniqueuserid(),menuId:menuId};
    let res = await this.menuService.GetMenuPermissionsByUserId(obj);
    if(res && res.isSuccess)
    {
      if(res.result.userMenus.length > 0)
      {
        res.result.userMenus.forEach((element:any) => {
          if(element.permissionName.toLowerCase() =="view")
          {
            this.canView = true;
            this.viewUrl = element.menuCommand;
          }
        });
      }      
    }
  }

  async loadInsurancePartners()
  {
    if(this.insuranceCopanyListTemp.length == 0){
      let response = await this._lookupService.PolicyLogInsuranceCompany();
      if (response?.isSuccess) {
        this.insuranceCopanyList = response.result.map((m:any)=> {return {name:m.name,id:m.id,checked:m.isChecked}});
        this.insuranceCopanyListTemp = response.result.map((m:any)=> {return {name:m.name,id:m.id,checked:m.isChecked}});
      }
    }
    else
    {
      this.insuranceCopanyList = JSON.parse(JSON.stringify(this.insuranceCopanyListTemp));
    }
  }

  onInsuranceCopanySelect(data:Item[]){
    this.selectedProductIds = "";
    this.selectedInsuranceCopanyIds = data.map((m:Item)=>{return m.id}).toString();
    this.loadApiNameList();
    this.loadProductList();
  }

  async loadProductList(){
    this.productList = [];
    //this.productList = [{name:"2 Wheeler", id:"2", checked:false},{name:"4 Wheeler", id:"1", checked:false},{name:"Commercial Vehicle", id:"3", checked:false},{name:"Health", id:"4", checked:false}];
    let res = await this._lookupService.PolicyLogProductName({id:this.selectedInsuranceCopanyIds});
    if (res != null && res.result) {
      this.productList = res.result.map((item:any)=> {return {name:item.name,value:item.id,id:item.id,checked:item.isChecked}});
    }
  }

  onInsuranceProductSelect(data:Item[]){
    this.selectedProductIds = data.map((m:Item)=>{return m.id}).toString();
  }

  async loadApiNameList(){
    this.apiNameList = [];
    //this.apiNameList =[{name:"Get Quote", id:"GetQuote", checked:true},{name:"Create Quote", id:"CreateQuote", checked:false},{name:"Kyc", id:"GetKyc", checked:false},{name:"Get Payment Link", id:"GetPaymentLink", checked:false},{name:"Payment Response", id:"PaymentResponse", checked:false},{name:"Policy Pdf", id:"GetPolicyReceiptPdf", checked:false}];
    let res = await this._lookupService.PolicyLogAPIName({id:this.selectedInsuranceCopanyIds});
    if (res != null && res.result) {
      this.apiNameList = res.result.map((item:any)=> {return {name:item.name,value:item.id,id:item.id,checked:item.isChecked}});
    }
  }

  onApiNameSelect(data:Item[]){
    this.selectedAPIName = data.map((m:Item)=>{return m.id}).toString();
  }

  async loadStatusList(){
    this.statusList =[{name:"Exception", id:"Exception", checked:false}, {name:"Failed", id:"Failed", checked:true}, {name:"Success", id:"Success", checked:false}];
  }

  onStatusSelect(data:Item[]){
    this.selectedStatus = data.map((m:Item)=>{return m.id}).toString();
  }

  setDateRange(dateRangeText:string){
    this.selectedDateRange = "Past "+ dateRangeText;
    switch(dateRangeText){
      case "2 Days" : 
      this.selectedStartDate = moment(this.today).add(-2, 'days').format();
      this.selectedEndDate = this.today; 
      break;
      case "7 Days" : 
      this.selectedStartDate = moment(this.today).add(-7, 'days').format();
      this.selectedEndDate = this.today;      
      break;
      case "1 Months" : 
      this.selectedStartDate = moment(this.today).add(-1, 'months').format();
      this.selectedEndDate = this.today;
      break;
      case "3 Months" : 
      this.selectedStartDate = moment(this.today).add(-3, 'months').format();
      this.selectedEndDate = this.today;
      break;
      case "6 Months" : 
      this.selectedStartDate = moment(this.today).add(-6, 'months').format();
      this.selectedEndDate = this.today;
      break;
      case "9 Months" : 
      this.selectedStartDate = moment(this.today).add(-9, 'months').format();
      this.selectedEndDate = this.today;
      break;
      case "Year" : 
      this.selectedStartDate = moment(this.today).add(-1, 'years').format();
      this.selectedEndDate = this.today;
      this.selectedDateRange = "Last " + dateRangeText;
      break;
    }
    //this.bindDashboardData();
  // moment(new Date()).add(10, 'days').format('DD/MM/YYYY')
  }

  onStartDateChange(event:any){
    this.selectedStartDate = event.value;
  }

  onEndDateChange(event:any){
    this.selectedEndDate = event.value;
  }
  
  async filterPolicyLogs(){
    this.getPolicyCompIncomDetails();
  }

  resetFilter(){
    this.selectedInsuranceCopanyIds = "";
    this.selectedProductIds = "";
    this.selectedStatus = "Failed";
    this.selectedAPIName = "GetQuote";
    this.selectedStartDate = moment(this.today).add(-1, 'days').format('YYYY-MM-DD');
    this.selectedEndDate = moment(this.today).format('YYYY-MM-DD');
    this.selectedDateRange = "Past 2 Days";

    this.loadInsurancePartners();
    this.loadProductList();
    this.loadApiNameList();
    this.loadStatusList();
    this.getPolicyCompIncomDetails();
  }

  async onDateRangeChange(selectedValues:any) {
    if(selectedValues?.length > 0){
      let dataArray = selectedValues.split('::');
      if(dataArray?.length > 2){
        this.selectedStartDate = dataArray[0];
        this.selectedEndDate = dataArray[1];
        this.selectedDateRange = dataArray[2];
      }
    }    
  }
}
